/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filter lists, based on checked and unchecked.
 * @usageNotes
 * The following shows how the pipe checkedUncheckedPipe can be used.
 * @param items The list which is to be sorted.
 * @param searchBasedOn Class member on which it is sorted.
 */

@Pipe({
  name: 'checkedUncheckedPipe',
  pure: false
})


export class CheckedUncheckedPipe implements PipeTransform {

  transform(items: any[], sortBasedOn: string): any[] {
  /**
    * @param items The list which is to be sorted.
    * @param searchBasedOn Class member on which it is sorted.
    */
    return this.sortItem(items, sortBasedOn);
  }

  private sortItem(items: any[], sortBasedOn: string): any[] {
    if (!items) {
      return [];
    }
    if ( !sortBasedOn) {
       return items;
    }
    let checkedArray: any = [], unCheckedArray: any = [];
    for (let item in items) {
      if (items[item].checked) {
        checkedArray.push(items[item]);
      } else {
        unCheckedArray.push(items[item]);
      }
    }
    checkedArray = checkedArray.sort((i1: any, i2: any) => {
      let x = i1[sortBasedOn].toLocaleLowerCase();
      let y = i2[sortBasedOn].toLocaleLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });
    unCheckedArray = unCheckedArray.sort((i1: any, i2: any) => {
      let x = i1[sortBasedOn].toLocaleLowerCase();
      let y = i2[sortBasedOn].toLocaleLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });

    return checkedArray.concat(unCheckedArray);
  }
}
